
import axios from "axios";
import { getOrCreateVisitorId } from "../helpers/storageUtils";
export const headers = {
  "Content-Type": "application/json",
};

const LeadService = (payload) => {
  let paraLocal = JSON.parse(localStorage.getItem("urlParams"));
  let user_unique_id = getOrCreateVisitorId();
  
  if (
    !payload ||
    !payload?.phone ||
    !/^\d{10}$/.test(payload.phone?.toString()?.trim())
  ) {
    return Promise.reject({ response: { data: { message: "Please enter the valid 10 digit number!"}}});
  }

  let userDetails = {
    name: payload?.name ?? null,
    phone: "+91" + payload?.phone,
    createdBy: "innovolt-website",
    language: "en",
    metaDataList: [
      {
        key: "UTM_SOURCE",
        value: paraLocal?.utm_source ?? "Organic",
      },
      {
        key: "UTM_CAMPAIGN",
        value: paraLocal?.utm_campaign ?? "999",
      },
      {
        key: "UTM_MEDIUM",
        value: paraLocal?.utm_medium ?? "Organic",
      },
      {
        key: "UTM_CONTENT",
        value: paraLocal?.utm_content ?? "Organic",
      },
      {
        key: "OFFER_SUB_SOURCE",
        value: payload?.subSource ?? "",
      },
      {
        key: "SOURCE_USER_ID",
        value: user_unique_id,
      },
      {
        key: "SOURCE_NAME",
        value: "innovolt-website",
      },
      {
        key: "UTM_TERM",
        value: paraLocal?.utm_term ?? "Unknown",
      },
      {
        key: "UTM_ENTIRE_URL",
        value: paraLocal?.entire_url ?? "",
      },
      {
        key: "WEBSITE_LANGUAGE",
        value: payload?.language ?? "en",
      },
    ],
  };
  
  return axios.post(
    `${process.env.NEXT_PUBLIC_API_ENDPOINT}v1/innovolt/leads/website`,
    userDetails
  );
};

export default LeadService;
